import React from 'react';
import './../styles/cliente.css';
import { Outlet } from 'react-router-dom';
import NavbarTop from './cliente/Navbartop';

const Cliente = () => {
    return (
        <div className="app-cliente app-container">
            <NavbarTop />
            <div className="main-content">
                <div className="page-container">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default Cliente;